import * as localForage from 'localforage';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadUser } from 'redux-oidc';
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';

import applicationReducer from './store/applicationReducer';
import accessTokenChangeMiddleware from './store/accessTokenChangeMiddleware';
import groupChangeLoggingMiddleware from './store/groupChangeLoggingMiddleware';
import { initialApplicationState } from './store/applicationState';
import userManager from './userManager';

const persistConfig = {
    key: 'community',
    storage: localForage,
    whitelist: ['groupData'],
    stateReconciler: autoMergeLevel2
}

const initialState = initialApplicationState;
const persistedReducer = persistReducer(persistConfig, applicationReducer);
const store = createStore(persistedReducer, initialState, composeWithDevTools(applyMiddleware(thunk, groupChangeLoggingMiddleware, accessTokenChangeMiddleware)));
const persistor = persistStore(store);

export default async () => {
    await loadUser(store, await userManager);
    return { store, persistor }
}